import { VariantAttributeResponse } from "src/types/service";

export const mappingValueAttributeVariant = (variantAttribute: VariantAttributeResponse) =>
    variantAttribute.value === "Default Title" ? "Mặc Định" : variantAttribute.value;
